import { Page, BlockStack } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import { useTransferClient } from '../components/transfers/useTransferClient';
import { TransferDraft } from '../components/transfers/TransferDraft';
import { TransferFeedback } from '../components/transfers/TransferFeedback';
export default function CreateTransferOrder() {
  const navigate = useNavigate();
  const client = useTransferClient();
  return (
    <Page
      title="Create warehouse transfer"
      backAction={{ content: 'Transfers', onAction: () => navigate('/transfer-orders') }}
    >
      <BlockStack gap="400">
        <TransferFeedback client={client} />
        <TransferDraft key={client.key} client={client} />
      </BlockStack>
    </Page>
  );
}
